import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../../styles/module/carousel.css";

// import bg4 from "../../assets/images/img/bg-4.webp";

const slides = [
  {
    title: "Discovery & Requirement Gathering",
    desc: "We begin by understanding your business objectives, key data sources, and the specific questions you want to answer through data.",
  },
  {
    title: "Data Collection & Integration",
    desc: "We gather data from various systems, platforms, or databases and ensure it's properly structured, cleaned, and integrated for analysis.",
  },
  {
    title: "Data Modeling & Strategy",
    desc: "Using the collected data, we define metrics, build models, and choose the right analytics approach to align with your business goals.",
  },
  {
    title: "Visualization & Dashboard Design",
    desc: "We design clear, interactive dashboards and reports that highlight key insights and make complex data easy to understand.",
  },
  {
    title: "Insight Generation & Validation",
    desc: "We analyze the data to extract meaningful trends, patterns, and correlations—then validate them to ensure accuracy and relevance.",
  },
  {
    title: "Deployment & Sharing",
    desc: "We deploy the dashboards and reports securely across your organization, enabling teams to access and act on insights in real-time.",
  },
  {
    title: "Monitoring & Optimization",
    desc: "We provide ongoing support to refine your analytics setup, track performance, and adapt to new business questions or data sources.",
  },
];

export default function AnalyticsSlider() {
  useScrollReveal("slide-from-left");
  useScrollReveal("drop-from-top");
  useScrollReveal("slide-from-bottom");
  const settings = {
    dots: true, // Show dots
    infinite: false, // Do not loop infinitely
    speed: 500, // Slide animation speed
    slidesToShow: 3, // Show 3 slides at once
    slidesToScroll: 1, // Scroll one slide at a time
    swipeToSlide: true, // Allow drag/swipe
    arrows: false, // Show arrows
    responsive: [
      // Responsive settings for smaller screens
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };
  return (
    <div id="karuzela" className="section section__carousel">
      {/* <img
        className="container-bg image-background left slide-from-left"
        src={bg4}
        alt="container background"
        style={{ marginTop: "400px" }}
      /> */}
      <div className="container carousel">
        <h5 className="drop-from-top">step by step</h5>
        <div className="title flex drop-from-top">
          <h2 style={{ marginBottom: 30 }}>
            What does the Data Analytics & Insights process look like?
          </h2>
        </div>

        <div className="carousel-slider slick-initialized slick-slider slick-dotted slide-from-bottom">
          <div className="slick-list draggable">
            <Slider {...settings}>
              {slides.map((slide, index) => (
                <div key={index} className="card" style={{ padding: 10 }}>
                  <div className="card-element">
                    <h6 className="title">{slide.title}</h6>
                    <span className="desc mini">{slide.desc}</span>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
}
